import { render } from "./ClientsManagerView.vue?vue&type=template&id=69a495b9"
import script from "./ClientsManagerView.vue?vue&type=script&lang=js"
export * from "./ClientsManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__